import React, { useState } from 'react';
import Button from '../elements/Button';
import { useHistory } from 'react-router-dom';
import Errors from './Errors';
import Success from './Success';
import Loader from './Loader';
import globals from '../globals';
import axios from 'axios';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const PHONE_REGEX = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;

const FlipToFibreRegisterForm = (props) => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState([]);
    const [formError, setFormError] = useState({
        firstName: {
            value: "first name",
            errorMessage: ""
        },
        lastName: {
            value: "last name",
            errorMessage: ""
        },
        email: {
            value: "email address",
            errorMessage: "",
            emailInvalidErrorMessage: ""
        },
        phoneNumber: {
            value: "contact number",
            errorMessage: "",
            phoneNumberInvalidErrorMessage: ""
        },
    })
    let history = useHistory();

    const { firstName, lastName, email, phoneNumber } = formData;

    const checkIfEmpty = () => {
        for (let key in formError) {
            if (formData[key].trim() === "") { 
                setHasError(true);
                setFormError(prevState => ({
                    ...prevState,
                    [key]: {         
                        ...formError[key],
                        errorMessage: `Please enter your ${formError[key].value}!`
                    }
                }));
            }
        }
    }

    const handleSubmitForm = (e) => {
        e.preventDefault();

        checkIfEmpty();

        if (firstName && lastName && email && phoneNumber && !hasError) {
            setIsLoading(true);
            let postFormData = {
                address: props.sqAddress,
                product: 'smb',
                ...formData
            };
            setTimeout(() => {
                setIsLoading(true);
                axios.post('/api/postFlipToFibreForm', postFormData).then(() => {
                    globals.pushEvent('gtm-FlipFibreFormSubmit');
                    setIsSuccess(true);
                    setIsLoading(false);
                }).catch(error => {
                    setIsSuccess(false);
                    setIsLoading(false);
                    setHasError(true);
                    if (error.response.status === 422) {
                        console.log(error.response);
                        setFormErrorMessage(error);
                    } else {
                        console.log(error.response);
                        setFormErrorMessage(error.response);
                    }
                })                                    
            }, 500);
        }

        setIsLoading(false);
    }

    const handleOnChange = (e) => {        
        for (let key in formError) {
            if (e.target.name === key) {
                setHasError(false);
                setFormError(prevState => ({
                    ...prevState,
                    [key]: {         
                        ...formError[key],
                        errorMessage: ""
                    }
                })); 
                
                if (key === "email") {  
                    const valid = EMAIL_REGEX.test(e.target.value);            
                    if (!valid) {
                        setHasError(true);
                        setFormError({
                            ...formError,
                            email: {
                                value: "email address",
                                errorMessage: "",
                                emailInvalidErrorMessage: "Please enter a valid Email Address!"
                            }
                        })
                    } else {
                        setHasError(false);
                        setFormError({
                            ...formError,
                            email: {
                                value: "email address",
                                errorMessage: "",
                                emailInvalidErrorMessage: ""
                            }
                        })
                    }
                }

                if (key === "phoneNumber") {
                    const valid = PHONE_REGEX.test(e.target.value);
                    if (!valid) {
                        setHasError(true);
                        setFormError({
                            ...formError,
                            phoneNumber: {
                                value: "phone number",
                                errorMessage: "",
                                phoneNumberInvalidErrorMessage: "Please enter a valid Contact Number!"
                            }
                        })
                    } else {
                        setHasError(false);
                        setFormError({
                            ...formError,
                            phoneNumber: {
                                value: "phone number",
                                errorMessage: "",
                                phoneNumberInvalidErrorMessage: ""
                            }
                        });
                    }
                }
            }
        }
        
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const showRegisterForm = () => {
        setShowForm(!showForm);
    }

    return (
        <React.Fragment>
            {!isSuccess ?
                <div className="flip-to-fibre-form">
                    <div>
                        <div className="action-row d-flex mb-3">
                            <button className="text-center mr-4 view-plans-btn btn-custom" onClick={showRegisterForm}>Register now</button>
                            <p className="font-small text-lg-left text-center">If you register your details below, we will <span className="color-lime">let you know</span> when you can Flip to Fibre™ and invite you back here to choose a plan.</p>
                        </div>
                        <div className="action-row d-flex mb-3">
                            <button className="text-center mr-4 view-plans-btn btn-custom btn-grey" onClick={() => history.push('small-business/nbn')}>Switch to <br />Exetel now</button>
                            <p className="font-small text-lg-left text-center">Alternatively, you can <span className="color-lime">switch to Exetel</span> now and we will keep you updated on exactly when you can Flip to Fibre™ as a valued Exetel customer.</p>
                        </div>
                    </div>
                    {showForm && <form className="mt-4" onSubmit={handleSubmitForm}>
                        <div className="row p-0">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="bold" htmlFor="firstName">First name</label>
                                    <input
                                        name="firstName"
                                        value={firstName}
                                        id="firstName"
                                        onChange={e => handleOnChange(e)}
                                        className="mb-4 form-control"
                                    />
                                </div>
                                {formError.firstName.errorMessage !== "" && <div className="m-0 mb-3 row-error text-left">{formError.firstName.errorMessage}</div>}
                                <div className="form-group">
                                    <label className="bold" htmlFor="lastName">Last name</label>
                                    <input
                                        name="lastName"
                                        value={lastName}
                                        id="lastName"
                                        onChange={e => handleOnChange(e)}
                                        className="mb-4 form-control"
                                    />
                                </div>
                                {formError.lastName.errorMessage !== "" && <div className="m-0 mb-3 row-error text-left">{formError.lastName.errorMessage}</div>}
                                <div className="form-group">
                                    <label className="bold" htmlFor="emailAddress">Email address</label>
                                    <input
                                        name="email"
                                        value={email}
                                        id="emailAddress"
                                        onChange={e => handleOnChange(e)}
                                        className="mb-4 form-control"
                                    />
                                </div>
                                {formError.email.errorMessage !== "" && <div className="m-0 mb-3 row-error text-left">{formError.email.errorMessage}</div>}
                                {formError.email.emailInvalidErrorMessage !== "" && <div className="m-0 mb-3 row-error text-left">{formError.email.emailInvalidErrorMessage}</div>}
                                <div className="form-group">
                                    <label className="bold" htmlFor="phoneNumber">Contact number <span className="regular">(Mobile or Home Phone)</span></label>
                                    <input
                                        name="phoneNumber"
                                        value={phoneNumber}
                                        type="tel"
                                        id="phoneNumber"
                                        onChange={e => handleOnChange(e)}
                                        className="mb-4 form-control"
                                    />                                    
                                </div>
                                {formError.phoneNumber.errorMessage !== "" && <div className="m-0 mb-3 row-error text-left">{formError.phoneNumber.errorMessage}</div>}
                                {formError.phoneNumber.phoneNumberInvalidErrorMessage !== "" &&  <div className="m-0 mb-3 row-error text-left">{formError.phoneNumber.phoneNumberInvalidErrorMessage}</div>}
                                {formErrorMessage.length !== 0 &&
                                    <React.Fragment>
                                        <Errors className="m-0 mb-3 text-left" errors={formErrorMessage.errors} />
                                        <p className="m-0 mt-2">
                                            Oops! Something went wrong, please give us a call on <a href="tel: 133938">13 39 38</a>
                                        </p>
                                    </React.Fragment>
                                }
                                <button className={`text-center mt-3 btn btn-custom ${isLoading ? "loading-btn" : ""}`} type="submit" >{isLoading ? <Loader /> : "Register"}</button>
                                <p className="font-small mt-4">
                                    By lodging your details here, you agree that Exetel may contact you with information about our services. Learn about how we handle your <a href="https://files.exetel.com.au/terms/ExetelPrivacyPolicy.pdf" target="_blank">private information</a>.
                                </p>
                            </div>
                        </div>
                    </form>}
                </div>
                :
                <div className="success-container">
                    <img className="mb-5" src="/images/paper-plane.svg" alt="successful" />
                    <h3 className="bold m-0">Your message has successfully sent.</h3>
                    <button className="view-plans-btn mt-3" onClick={props.handleHideResults}>Close</button>
                </div>
            }
        </React.Fragment>
    )
}
export default FlipToFibreRegisterForm


// WEBPACK FOOTER //
// ./resources/assets/js/elements/FlipToFibreRegisterForm.js